import { OrderCalculation, ProductVariantSummary, TicketGroup } from '../types'

interface GtmItem {
    item_id: string
    item_name: string
    price: string
    quantity: string
}

export const handleGtmPay = function (calc: OrderCalculation): void {
    window.dataLayer = window.dataLayer || []

    // Clear previous ecommerce data
    window.dataLayer.push({ ecommerce: null })

    const items = [
        ...calc.tickets.map(
            (item: TicketGroup): GtmItem => ({
                item_id: item.typeId.toString(),
                item_name: item.name,
                price: Number(item.unitPrice).toFixed(2),
                quantity: item.quantity.toString(),
            }),
        ),
        ...calc.products.map(
            (item: ProductVariantSummary): GtmItem => ({
                item_id: item.name,
                item_name: item.name,
                price: Number(item.unitPrice).toFixed(2),
                quantity: item.quantity.toString(),
            }),
        ),
    ]

    const total = items.reduce((sum, item) => sum + Number(item.price) * Number(item.quantity), 0)

    window.dataLayer.push({
        event: 'purchase',
        ecommerce: {
            transaction_id: `T_${Date.now()}`,
            value: Number(total).toFixed(2),
            tax: Number(total * 0.24).toFixed(2),
            shipping: '0.00',
            currency: 'EUR',
            items,
        },
    })
}
